import { galleryStore } from "@customer-gallery/redux/store";
import {
    customerGalleryPrefix,
    PASSWORDLESS_SIX_DIGIT_CODE_EXPIRATION_TIMEOUT,
    NOVEL_PASS_USER_EMAIL_PARAM,
} from "@novel/shared/utils/appConstants";
import { checkIsMobile } from "@novel/shared/utils/userAgentUtils";
import { Unsubscribe } from "redux";
import { typedFrontendGalleryApi } from "@customer-gallery/utils/typedFrontendGalleryApi";
import { stringify } from "qs";
import { appPrefixedHostWithProtocol } from "@novel/shared/utils/appDomainConstants";

const BASE_AUTH_LINK = `${appPrefixedHostWithProtocol}${customerGalleryPrefix}/login`;
let currentAuthLink = BASE_AUTH_LINK;
let currentTimeout: number;
let initialized = false;

export function getAuthLink(): string {
    const authLinkValue = currentAuthLink;

    // creates new auth link in the background as we assume we're about to use the one we just made
    const TEN_MINUTES = 600000; // assumed max amount of time loading the redirect will take
    if (initialized) {
        setTimeout(populateAuthLink, TEN_MINUTES);
    }

    return authLinkValue;
}

let unsubscribe: Unsubscribe;
if (typeof window !== "undefined") {
    // only needed for mobile redirect atm
    if (checkIsMobile()) {
        unsubscribe = galleryStore.subscribe(initPopulatingAuthLinkOnLogin);
    }
}

function initPopulatingAuthLinkOnLogin() {
    const state = galleryStore.getState();

    if (state.auth.user) {
        populateAuthLink();
        unsubscribe();
    }
}

async function populateAuthLink(): Promise<void> {
    initialized = true;
    const result = await typedFrontendGalleryApi.postReq("/api/customer/auth/passwordless/code");
    clearTimeout(currentTimeout);

    if (result.type === "success") {
        const redirectAppUrl =
            typeof window !== "undefined"
                ? `${window.location.pathname.replace(customerGalleryPrefix, "") || "/"}${
                      window.location.search
                  }`
                : "/";
        currentAuthLink = `${BASE_AUTH_LINK}${stringify(
            {
                [NOVEL_PASS_USER_EMAIL_PARAM]: result.body.email,
                code: result.body.code,
                redirectAppUrl: encodeURIComponent(redirectAppUrl),
            },
            {
                addQueryPrefix: true,
            },
        )}`;

        // refresh the link 30 seconds before it times out
        currentTimeout = setTimeout(
            populateAuthLink,
            PASSWORDLESS_SIX_DIGIT_CODE_EXPIRATION_TIMEOUT - 30000,
        ) as any;
    } else {
        const ERROR_RETRY_WAIT_TIME = 60000; // retry in one minute if failed
        currentTimeout = setTimeout(populateAuthLink, ERROR_RETRY_WAIT_TIME) as any;

        throw result.error;
    }
}
